import React, { Component } from 'react';
import classNames from 'classnames';
import Fade from 'react-reveal/Fade';
import { view } from 'react-easy-state';
import Store from '../store/store';
// import PrestBtnMod from './PrestBtnMod';
import PrestBtnDel from './PrestBtnDel';
import PrestChoice from './PrestChoice';
import PrestImpegnativa from './PrestImpegnativa';
import { withTranslation } from 'react-i18next';

class PrestBlock extends Component {  
  onClickModifica = () => {
    const { idx } = this.props;
    const { resetPrestazione } = Store;
    
    resetPrestazione(idx);
  }

  onClickElimina = () => {
    const { idx } = this.props;
    const { deletePrestazione } = Store;
    
    deletePrestazione(idx);
  }

  onClickContinua = () => {
    const { idx } = this.props;
    const { updatePrestazione } = Store;
    
    updatePrestazione(idx, 'isComplete', true);
  }

  onClickAddPrestazione = () => {
    const { addPrestazione } = Store;
    
    addPrestazione();
  }

  onClickGoInsDati = () => {
    const { startAnagrafica } = Store;
    
    startAnagrafica();
  }

  render() {
    const { t } = this.props;
    const { 
      prestazioni, canShowCompleteStuffs, showDelBtn
    } = Store;
    const { idx } = this.props;
    const prestazione = prestazioni[idx];

    const prestBlockClass = classNames({
      'kfpr-box': true,
      'kfpr-box-prest': !prestazione.get('isComplete'),
      'kfpr-box-prest-ok': prestazione.get('isComplete'),
    });

    const contClass = classNames({
      'kfpr-prest': true,
      'kfpr-prest-recap': Store.isSent
    });

    return (
      <div className={contClass}>
        <div className="kfpr-row kfpr-row-top">
          <div className="kfpr-row-top-num">
            <span>{t('PRESTAZIONE N')}</span> 
            <strong>{idx + 1}</strong> 
          </div>
          <div className="kfpr-row-top-link">
            {
              showDelBtn(idx) &&
              <PrestBtnDel idx={idx} onClick={this.onClickElimina} />
            }
          </div>
        </div>
        
        <div className={prestBlockClass}>
          <div className="kfpr-box-inner">
             <PrestChoice idx={idx} onClickModifica={this.onClickModifica} />
             <PrestImpegnativa idx={idx} />
          </div>
        </div>
        {
        canShowCompleteStuffs(idx) && 
        <Fade top duration={400}>
          <div className="kfpr-box kfpr-box-message kfpr-box-message-ok">
              <div className="kfpr-box-inner">
                  <div className="kfpr-cont">
                      <div className="kfpr-row kfpr-row-head">
                          <span>{t("prestazione")}</span>
                          <strong>{prestazione.get('name')}</strong>
                      </div>                                
                      <div className="kfpr-row">
                          {t("Correttamente registrata, è necessario inserire i dati personali per concludere la richiesta")}
                      </div>
                  </div>
              </div>                        
          </div>
        </Fade>
        }

        {
          canShowCompleteStuffs(idx) && 
          <Fade bottom duration={400}>
            <div className="kfpr-row kfpr-row-txt kfpr-row-txt-big kfpr-alert"> 
                <div className="kfpr-alert-msg">
                    <strong>{t("Attenzione")}:</strong>
                    {t("La richiesta di prenotazione non è ancora completata")}
                </div>                        
                <p>{t("Come desideri procedere ora")}?</p>
                
                <div className="kfpr-row kfpr-row-btn kfpr-alert-btn">
                    <div className="button big hasicon as-a" role="button" onClick={this.onClickAddPrestazione}>
                        <img alt="" className="ico-btn" src="/wp-content/uploads/2019/06/kfpr-ico-prestazione-white.png" />
                        <span>{t("Aggiungi Prestazione")}</span>
                    </div>
                    <div className="button big orange hasicon as-a" role="button" onClick={this.onClickGoInsDati}>
                        <img alt="" className="ico-btn" src="/wp-content/uploads/2019/06/kfpr-ico-dati-white.png" />         
                        <span>{t("Inserisci i tuoi dati")}</span>
                    </div>                                            
                </div>
            </div>
          </Fade>
        }
      </div>
    );
  }
}

export default withTranslation()(view(PrestBlock));